// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown'
import UserDropdown from './UserDropdown'
import NotificationDropdown from './NotificationDropdown'
import { useEffect, useRef ,useState} from 'react'
// ** Third Party Components
import { Sun, Moon, Bell } from 'react-feather'
import './style.css'
// ** Reactstrap Imports
import { Badge, DropdownToggle, NavItem, NavLink } from 'reactstrap'
import { BiNotification } from 'react-icons/bi'
import { MdNotificationAdd, MdNotificationImportant, MdNotifications } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import NotificationBadge from 'react-notification-badge';
import { useSelector } from 'react-redux'

const NavbarUser = props => {
  // ** Props
  const { skin, setSkin } = props
const [isActive, setIsActive] = useState(false);
  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon' onClick={() => setSkin('dark')} />
    }
  }

  const navigate=useNavigate()
  const {
    Notification
  } = useSelector((state) => state);
  const [Length,setLength]=useState(0)
  useEffect(()=>{
    setLength(Notification.length > 9 ? "+9" : Notification.length)
  }, [Notification])
  return (
    <ul className="nav navbar-nav align-items-center ms-auto">
      <div className="notification-bell">
        <Bell style={{ cursor: "pointer" }} onClick={() => {
          navigate('/Setup/Notfications')
        }} size={21} />
        <Badge color="danger">{Length}</Badge>
      </div>
        
        {/* <Badge  color="danger" >
          11
        </Badge> */}
      
        <div></div>
      <IntlDropdown />
      <NavItem className=" d-lg-block">
        <NavLink >
          <ThemeToggler />
        </NavLink>
      </NavItem>
      <NotificationDropdown />
      <UserDropdown/>
    </ul>
  );
}
export default NavbarUser
